"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.promise.js");
require("core-js/modules/web.timers.js");
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _react = require("react");
var visibleTooltipCount = 0;

/**
 * 控制 Tooltip 的触发机制
 *
 * Tooltip 跟普通的 Bubble 不一样：
 *
 * 1. 出现位置不参考元素，参考鼠标
 * 2. 如果场上无 Tooltip 实例，则激活后 0.6s 后弹出
 * 3. 如果场上有 Tooltip 实例，则激活后 0.3s 后弹出
 *
 * 设计上面的规则，是为了对齐系统 Tooltip 的交互
 */
var TooltipTrigger = function TooltipTrigger(_ref) {
  var delay = _ref.delay,
    _ref$openDelay = _ref.openDelay,
    openDelay = _ref$openDelay === void 0 ? delay : _ref$openDelay,
    _ref$closeDelay = _ref.closeDelay,
    closeDelay = _ref$closeDelay === void 0 ? 0 : _ref$closeDelay,
    setVisible = _ref.setVisible,
    render = _ref.render,
    openDelayWhenHasInstance = _ref.openDelayWhenHasInstance;
  // 当前鼠标的位置，用作 Tooltip 弹出位置的参考
  var mouseElement = (0, _react.useRef)(null);

  // Tooltip 确定要激活，在延时出来期间，需要监听鼠标新位置，这个引用保存监听的取消方法
  var mouseWatching = (0, _react.useRef)(null);

  // 从鼠标事件获得的坐标信息，构造鼠标参考位置
  var mark = (0, _react.useRef)(function (evt) {
    var width = 0;
    var height = 0;
    var clientX = Math.round(evt.clientX);
    var clientY = Math.round(evt.clientY);
    mouseElement.current = {
      clientWidth: width,
      clientHeight: height,
      getBoundingClientRect: function getBoundingClientRect() {
        return {
          left: clientX,
          top: clientY,
          right: clientX + width,
          bottom: clientY + height,
          width: width,
          height: height
        };
      },
      // IE10 下 Popper 读取这两个值计算
      scrollTop: 0,
      scrollLeft: 0
    };
  });

  // 监听鼠标位置变化，更新位置
  var watch = function watch() {
    document.addEventListener('mousemove', mark.current);
    mouseWatching.current = function () {
      return document.removeEventListener('mousemove', mark.current);
    };
    return mouseWatching.current;
  };

  // 取消当前的位置变化监听
  var unwatch = function unwatch() {
    if (mouseWatching.current) {
      mouseWatching.current();
      mouseWatching.current = null;
    }
  };

  // 用户鼠标进入目标元素
  var enter = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(evt) {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            // 记录鼠标位置并跟踪
            mark.current(evt.nativeEvent);
            watch();
            // Tooltip 出来后，更新实例数量，并且可以取消跟踪了（Tooltip 出来的时候，鼠标在哪儿，就在哪儿，无需跟随）
            _context.next = 4;
            return setVisible(true, visibleTooltipCount > 0 ? openDelayWhenHasInstance : openDelay);
          case 4:
            visibleTooltipCount += 1;
            unwatch();
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function enter(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  // 用户鼠标离开目标元素
  var leave = /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            // 取消原有的跟踪
            unwatch();

            // 完全隐藏后，延时 1 秒更新实例数量
            // 这里延时 1 秒是给用户留足够的空间，不至于由于鼠标走的慢导致下次 Tooltip 又要等很久
            _context2.next = 3;
            return setVisible(false, closeDelay);
          case 3:
            _context2.next = 5;
            return new Promise(function (resolve) {
              return setTimeout(resolve, 1000);
            });
          case 5:
            visibleTooltipCount -= 1;
          case 6:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function leave() {
      return _ref3.apply(this, arguments);
    };
  }();

  // 组件 unmount 的时候，清理一切
  (0, _react.useEffect)(function () {
    return function () {
      mouseElement.current = null;
      mark.current = null;
      unwatch();
    };
  }, []);
  return render({
    childrenProps: {
      onMouseEnter: enter,
      onMouseLeave: leave
    },
    overlayProps: {},
    referenceElement: mouseElement.current
  });
};
var _default = exports.default = TooltipTrigger;